/* !
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Classes } from "@blueprintjs/core";
var NS = Classes.getClassNamespace();
export var CONTEXT_MENU2 = "".concat(NS, "-context-menu2");
export var CONTEXT_MENU2_VIRTUAL_TARGET = "".concat(CONTEXT_MENU2, "-virtual-target");
export var CONTEXT_MENU2_POPOVER2 = "".concat(CONTEXT_MENU2, "-popover2");
export var CONTEXT_MENU2_BACKDROP = "".concat(CONTEXT_MENU2, "-backdrop");
export var POPOVER2 = "".concat(NS, "-popover2");
export var POPOVER2_ARROW = "".concat(POPOVER2, "-arrow");
export var POPOVER2_BACKDROP = "".concat(POPOVER2, "-backdrop");
export var POPOVER2_CAPTURING_DISMISS = "".concat(POPOVER2, "-capturing-dismiss");
export var POPOVER2_CONTENT = "".concat(POPOVER2, "-content");
export var POPOVER2_CONTENT_PLACEMENT = "".concat(POPOVER2, "-placement");
export var POPOVER2_CONTENT_SIZING = "".concat(POPOVER2_CONTENT, "-sizing");
export var POPOVER2_DISMISS = "".concat(POPOVER2, "-dismiss");
export var POPOVER2_DISMISS_OVERRIDE = "".concat(POPOVER2_DISMISS, "-override");
export var POPOVER2_OPEN = "".concat(POPOVER2, "-open");
export var POPOVER2_POPPER_ESCAPED = "".concat(POPOVER2, "-popper-escaped");
export var POPOVER2_REFERENCE_HIDDEN = "".concat(POPOVER2, "-reference-hidden");
export var POPOVER2_TARGET = "".concat(POPOVER2, "-target");
export var POPOVER2_TRANSITION_CONTAINER = "".concat(POPOVER2, "-transition-container");
export var TOOLTIP2 = "".concat(NS, "-tooltip2");
export var TOOLTIP2_INDICATOR = "".concat(TOOLTIP2, "-indicator");
//# sourceMappingURL=classes.js.map